{
  "nl": {
    "item": {
      "deleted": "Verwijderde inhoud"
    }
  }
}
